<template lang="pug">
.v-search-section.search-section(v-if="data" :id="data?.id")
	.search-section__title(v-if="data.title") {{data.title}}
	.search-section__field
		v-scope
			v-field-search(:field="data.field" mode="modal" icon="graphic-search-2")
	.search-section__links(v-if="data.links")
		v-svg-icon.search-section__links-bg-pointer(icon="message-pointer")
		.search-section__links-title(v-if="data.links.title") {{data.links.title}}
		a.search-section__link(v-for="linkItem in data.links.items" :href="linkItem.link") {{linkItem.text}}
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>